import dayjs from 'dayjs'
import { i18n } from './lang'

export default {
  data() {
    return {
      dayjs
    }
  },
  methods: {
    formatDate(date, format = '') {
      const formatStr = format || i18n.t('date_format');
      return date ? dayjs(date).format(formatStr) : ''
    }
  }
}
